import hmacSHA256 from 'crypto-js/hmac-sha256'

import { IAuthDashlyParams } from './types'

import { isInStorage } from '@/utils/localStorage'

const isAnalyticsOff = isInStorage('isImpersonate')

export const openDashlyChat = () => {
  if (isAnalyticsOff) {
    return
  }

  if (window?.dashly?.open) {
    window.dashly.open()
  }
}

export const trackDashlyEvent = (event: string, data?: Record<string, any>) => {
  if (isAnalyticsOff) {
    return
  }

  if (window?.dashly?.track) {
    window.dashly.track(event, data)
  }
}

export const identifyDashlyUser = (data: Record<string, any>) => {
  if (isAnalyticsOff) {
    return
  }

  if (window?.dashly?.identify) {
    window.dashly.identify(data)
  }
}

export const authDashlyUser = ({ userId }: IAuthDashlyParams) => {
  if (isAnalyticsOff) {
    return
  }

  if (window?.dashly?.auth) {
    const authKey = process.env.REACT_APP_DASHLY_AUTH_KEY

    if (!authKey) {
      return
    }

    const transformedUserId = userId.toString()
    const hmac = hmacSHA256(transformedUserId, authKey).toString()

    window.dashly.auth(transformedUserId, hmac)
  }
}
